import { Body2 } from 'ui/theme';
import { Cell } from '../../../../components/table';
import { TableColumn } from './constants';
import { ExtendedMessageType } from '../../../types';

type StatusCellProps = {
  messageType: ExtendedMessageType;
};

export const StatusCell = ({ messageType }: StatusCellProps) => {
  const { isSubscribed, isPendingSubscription } = messageType;
  const getLabel = () => {
    if (isPendingSubscription) return 'Pending';
    else if (isSubscribed) return 'Yes';
    else return 'No';
  };
  return (
    <Cell columnId={TableColumn.status}>
      <Body2>{getLabel()}</Body2>
    </Cell>
  );
};
